import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class PublisherStore {
    version = '1.0';

    featuredPublishers = [];
    featuredSection = {
        label: 'FEATURED',
        title: 'In the spotlight',
        description: 'The biggest brands and breakout names on ECAL right now — sync them straight to your calendar in a few taps.',
    };

    whatshotPublishers = [];
    whatsHotPublisherIds = {};   // { [pubId]: 'true' } — O(1) lookup for directory whatshot filter
    popularNowPublishers = [];
    originNearMePublishers = [];   // raw API response — never mutated after fetch
    nearMePublishers = [];         // originNearMePublishers, deduped against popularNowPublishers
    recommendedPublishers = [];
    totalSubscribers = null;   // global site-wide count — fetched once per load via usePublisherInit()
    widgetParamsMap = { publishers: {} };   // pubId -> { name, widgetParamsString } — overrides a publisher's own widgetParamsString when present

    directoryPublishers = [];             // all pages loaded so far — browse mode (no search)
    filteredDirectoryPublishers = [];     // result of applyDirectoryFilter
    directoryFilterIndustries = [];
    directoryPage = 1;                    // last browse page fetched — guard field, not observed
    directoryHasMore = true;              // browse mode's hasNextPage — guard field, not observed

    // Search mode (EBL-13117) — a separate pool/cursor from browse mode above,
    // so clearing the search box reveals the browse list exactly as it was
    // (already-loaded pages, scroll position) instead of losing it.
    searchDirectoryResults = [];
    searchPage = 1;
    searchHasMore = true;
    // Which query searchDirectoryResults/searchPage/searchHasMore actually
    // belong to — search.searchText updates the instant a keystroke settles
    // (setSearchText), separately from and ahead of the async fetch that
    // resolves those fields for that query. loadMoreSearchResults checks
    // this matches search.searchText before trusting searchHasMore, so a
    // load-more triggered in that gap (e.g. VirtuosoGrid's endReached firing
    // again as soon as a short result set renders) can't fire against a
    // newer query using a still-stale hasMore/page from the previous one.
    searchQuery = '';

    search = {
        whatshotEnabled: false,
        searchText: '',
        industryFilters: [],
    };

    observed = {
        // Start true so every section renders its skeleton immediately, before
        // initPublisherData's first fetch has even had a chance to flip these —
        // each action still sets/resets the real value once it actually runs.
        featuredPublishersLoading: true,
        whatshotPublishersLoading: true,
        popularNowPublishersLoading: true,
        nearMePublishersLoading: true,
        directoryPublishersLoading: true,
        directoryPublishersLoadingMore: false,
        directoryPublishersSearching: false,
        directoryPublishersSearchingMore: false,
        recommendedPublishersLoading: true,
        totalSubscribersLoading: true,
    };

    constructor() {
        makeObservable(this, { observed: observable });
        withActions(this, actions);
    }
}

export function usePublisherStore() {
    const { store } = useStores();
    return store.publisherStore;
}
